export default __webpack_public_path__ + "static/media/ecogas-new.0f668ee4.png";